// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__LwMAv","outline":"Button_outline__2fD_Y","small":"Button_small__3g1wS"};